import Plyr from 'plyr';
const player = new Plyr('#player');

const parkPlayer = new Plyr('#park-player', {
    controls: ["play", "progress", "current-time", "volume"]
});

const players = Array.from(document.querySelectorAll('.oval-player')).map(p => new Plyr(p, {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings']
}));